"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.httpClientFactory = void 0;
var _axios = _interopRequireDefault(require("axios"));
var _axiosRetry = _interopRequireDefault(require("axios-retry"));
var _apiKeyManager = require("./apiKeyManager");
var _errors = require("../../types/errors");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
/**
 * @typedef {import('axios').Axios} AxiosInstance
 */
/**
 *
 * @param { AxiosInstance } axiosInstance
 * @returns
 */
var addApiKeyInterceptor = function addApiKeyInterceptor(apiKey, clientId, axiosInstance) {
  axiosInstance.interceptors.request.use(function (request) {
    var headersToBeAdded = {
      Pragma: 'no-cache',
      Expires: 'Thursday, 01 Jan 1970 00:00:00 GMT',
      'If-Modified-Since': 'Mon, 26 Jul 1997 05:00:00 GMT',
      'Content-Type': 'application/json',
      Authorization: "API-Key ".concat((0, _apiKeyManager.getApiKeyManager)(apiKey, clientId).getApiKey())
    };
    Object.entries(headersToBeAdded).forEach(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];
      request.headers.set(key, value);
    });
    return request;
  }, function (error) {
    return Promise.reject(error);
  });
  return axiosInstance;
};

/**
 *
 * @param { AxiosInstance } axiosInstance
 */
var addRequestRetryInterceptor = function addRequestRetryInterceptor(apiKey, clientId, axiosInstance) {
  (0, _axiosRetry["default"])(axiosInstance, {
    retries: 1,
    retryDelay: function retryDelay() {
      return 500;
    },
    retryCondition: function retryCondition(error) {
      return !!error;
    },
    onRetry: function onRetry() {
      /* Reset api key on retry  */
      (0, _apiKeyManager.getApiKeyManager)(apiKey, clientId).resetApiKeyExpiry();
    }
  });
  return axiosInstance;
};

/**
 *
 * @param { AxiosInstance } axiosInstance
 * @param { boolean } useMocks
 */
var addErrorResponseInterceptor = function addErrorResponseInterceptor(axiosInstance, useMocks) {
  axiosInstance.interceptors.response.use(function (response) {
    var _errorTypeByStatusCod;
    var statusCode = response.status !== 200 || useMocks ? response.status : response === null || response === void 0 ? void 0 : response.data.statusCode;
    var isSuccess = response.status.toString().startsWith('2') && (statusCode === null || statusCode === void 0 ? void 0 : statusCode.toString().startsWith('2'));
    if (isSuccess) {
      return response;
    }
    var errorTypeByStatusCode = {
      400: _errors.BadRequestError,
      404: _errors.ResourceNotFoundError,
      503: _errors.ServiceNotAvailableError,
      500: _errors.InternalServerError
    };
    var ErrorType = (_errorTypeByStatusCod = errorTypeByStatusCode[statusCode]) !== null && _errorTypeByStatusCod !== void 0 ? _errorTypeByStatusCod : _errors.QuoteError;
    var error = new ErrorType();
    /* Needed for axios to retry 2xx request with payload.statusCode !== 200 */
    error.config = response.config;
    error.response = response;
    throw error;
  });
};

/**
 *
 * @returns { AxiosInstance } The http client instance
 */
var createHttpClient = function createHttpClient() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    apiKey: '',
    clientId: '',
    baseURL: '',
    hasApiKey: true,
    useMocks: false
  };
  var instance = _axios["default"].create({
    baseURL: config.baseURL
  });
  if (config.hasApiKey) {
    addApiKeyInterceptor(config.apiKey, config.clientId, instance);
  }
  addErrorResponseInterceptor(instance, config.useMocks);
  addRequestRetryInterceptor(config.apiKey, config.clientId, instance);
  return instance;
};
var createAbortController = function createAbortController() {
  return new AbortController();
};
var httpClientFactory = exports.httpClientFactory = {
  create: createHttpClient,
  createAbortController: createAbortController,
  all: _axios["default"].all
};